import React from 'react';
import { Router } from 'react-router-dom';
import Alert from './containers/common/Alert';
import HeaderRoutes from './routes/HeaderRoutes';
import MainRoutes from './routes/MainRoutes';
import Footer from './components/blocks/Footer';
import history from './utils/history';

export function InitApp() {
  return (
    <Router history={history}>
      <div id="mainContainer">
        <Alert />
        <HeaderRoutes />
        <MainRoutes />
        <Footer />
      </div>
    </Router>
  );
}
